
export default function initAddIndentHeaderClass() {
	var main = jQuery('#main');
	var headerEl= jQuery('.header');
	var headerClass = 'indent-lg';

	if(main.children().first().hasClass('hero-section') || main.children().first().hasClass('floorplan-section')) {
		headerEl.addClass(headerClass);
	}
}
